<template>
  <div id="app">
    <router-view/>
    <portal-target name="body-bottom-container" multiple />
  </div>
</template>

<script>
export default {
  data(){
    return {
      beforeUnloadHandler: null,
      keydownHandler: null
    }
  },
  mounted() {
    // this.$request.General.getFeedbackState()
    // .then((res) => {
    //   console.log(res);
    // }).catch((err) => {
    //   console.log(err);
    // });
    
    // 监听键盘刷新事件（F5、Ctrl+R等）
    this.handleKeyboardRefresh();
    // 监听页面关闭/导航离开事件
    this.handleBeforeUnload();
  },
  methods: {
    // 处理键盘刷新事件（F5、Ctrl+R、Ctrl+F5等）
    handleKeyboardRefresh() {
      this.keydownHandler = (e) => {
        // 检测 F5 或 Ctrl+R 或 Ctrl+Shift+R（强制刷新）
        const isF5 = e.key === 'F5' || e.keyCode === 116;
        const isCtrlR = (e.ctrlKey || e.metaKey) && (e.key === 'r' || e.key === 'R' || e.keyCode === 82);
        const isCtrlShiftR = (e.ctrlKey || e.metaKey) && e.shiftKey && (e.key === 'r' || e.key === 'R' || e.keyCode === 82);
        
        if (isF5 || isCtrlR || isCtrlShiftR) {
          e.preventDefault();
          e.stopPropagation();
          this.showRefreshConfirm();
        }
      };
      
      window.addEventListener('keydown', this.keydownHandler, true);
    },
    
    // 显示刷新确认弹窗
    showRefreshConfirm() {
      this.$confirm('你所做的更改可能未保存', '重新加载站点?', {
        confirmButtonText: '重新加载',
        cancelButtonText: '取消',
        type: 'warning',
        closeOnClickModal: false,
        closeOnPressEscape: false
      }).then(() => {
        // 用户点击重新加载，刷新页面
        window.location.reload();
      }).catch(() => {
        // 用户点击取消，不执行任何操作
      });
    },
    
    // 处理页面关闭/导航离开事件
    handleBeforeUnload() {
      // 保存事件处理函数的引用，以便后续移除
      this.beforeUnloadHandler = (e) => {
        // 阻止默认行为
        e.preventDefault();
        // Chrome 需要设置 returnValue
        e.returnValue = '你所做的更改可能未保存';
        // 返回提示文本（虽然现代浏览器可能不会显示自定义文本，但会显示确认对话框）
        return '你所做的更改可能未保存';
      };
      
      window.addEventListener('beforeunload', this.beforeUnloadHandler);
    }
  },
  beforeDestroy() {
    // 组件销毁时移除事件监听
    if (this.beforeUnloadHandler) {
      window.removeEventListener('beforeunload', this.beforeUnloadHandler);
    }
    if (this.keydownHandler) {
      window.removeEventListener('keydown', this.keydownHandler);
    }
  }
}
</script>

<style lang="scss">
@import "@/assets/css/style.scss";
</style>
